export const businessFolders = state => state.businessFolders
export const businessFolder = state => state.businessFolder